import { render } from "./modal_root.vue?vue&type=template&id=49e1e494"
import script from "./modal_root.vue?vue&type=script&lang=js"
export * from "./modal_root.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__